import { createSlice } from "@reduxjs/toolkit";
import { resetPatientData } from "../../../system/store/reset.slice";

const initialState = {
  data: null,
};

export const allergiesSlice = createSlice({
  name: "entities/patient-stats/allergies-slice",
  initialState,
  reducers: {
    setAllergies: (state, action) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetPatientData, () => initialState);
  },
});

export const { setAllergies } = allergiesSlice.actions;

export default allergiesSlice.reducer;
